var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled } from '../theme-provider';
import { getCommonProps } from '../helpers/common-props';
const StyledDivider = styled.hr.withConfig({ displayName: "StyledDivider", componentId: "sc-1g6khxq" }) `border:none;width:${(props) => props.isVertical ? props.theme.size.line.default : 'initial'};height:${(props) => props.isVertical ? '100%' : props.theme.size.line.default};margin:0;background-color:${(props) => props.theme.colors.border.divider};`;
export const Divider = (props) => {
    const { isVertical } = props, rest = __rest(props, ["isVertical"]);
    const commonProps = getCommonProps(props);
    return React.createElement(StyledDivider, Object.assign({ isVertical: isVertical }, commonProps, rest));
};
Divider.displayName = 'Divider';
